import { render, staticRenderFns } from "./recoverPassword.vue?vue&type=template&id=5c45c117&scoped=true&"
import script from "./recoverPassword.vue?vue&type=script&lang=js&"
export * from "./recoverPassword.vue?vue&type=script&lang=js&"
import style0 from "./recoverPassword.vue?vue&type=style&index=0&id=5c45c117&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c45c117",
  null
  
)

export default component.exports